











import Vue from "vue";

import BadgeDrillListening from "@joyz/app-core/assets/badge/DrillListening.svg";
import BadgeDrillPronunciation from "@joyz/app-core/assets/badge/DrillPronunciation.svg";
import BadgeDrillVocabulary from "@joyz/app-core/assets/badge/DrillVocabulary.svg";

import { DrillState, ExerciseType } from "@tt-app/models/exercise";
import { EXERCISE_TYPE } from "@tt-app/constants";

interface Data {
  extend: boolean;
  show: boolean;
}

interface Computed {
  badgeIcon: string;
}

interface Props {
  displayDelay: number;
  drill: DrillState;
  exerciseType: ExerciseType;
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: "DrillLearnedBadgeToast",
  components: {},

  props: {
    displayDelay: { type: Number, default: 2000 },
    drill: { type: Object as () => DrillState, required: true },
    exerciseType: { type: Number as () => ExerciseType, required: true }
  },

  data() {
    return { show: false, extend: false };
  },

  computed: {
    badgeIcon() {
      switch (this.exerciseType) {
        case EXERCISE_TYPE.DRILL_PRONUNCIATION:
          return BadgeDrillPronunciation;
        case EXERCISE_TYPE.DRILL_LISTENING:
          return BadgeDrillListening;
        case EXERCISE_TYPE.DRILL_VOCABULARY:
          return BadgeDrillVocabulary;
        default:
          throw new Error(`Invalid exercise type: ${this.exerciseType}`);
      }
    }
  },

  watch: {
    "drill.totalNewLearnedBadge": {
      handler(newCount: number, oldCount: number) {
        if (newCount <= oldCount) {
          return;
        }

        if (!this.drill.data?.course) {
          this.extend = this.drill.currentIndex === this.drill.exercises.length - 1;
        }

        this.show = true;
        window.setTimeout(() => {
          this.show = false;
        }, this.displayDelay);
      }
    }
  },

  methods: {}
});
